import Model, { attr, belongsTo } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';
import type CustomTagDefinition from 'lumen/models/custom-tag-definition';

export default class CustomTagListOption extends Model {
  [Type] = 'custom-tag-list-option' as const;

  @belongsTo('custom-tag-definition', { async: false, inverse: 'options' })
  declare definition: CustomTagDefinition;

  @attr('string') declare label: string;
  @attr('number') declare subscriberCount: number;
}
